import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
  selector: 'app-otp-code',
  templateUrl: './otp-code.component.html',
  styleUrls: ['./otp-code.component.css'],
})
export class OtpCodeComponent {
  otpArray: string[] = Array(6).fill('');
  otpValues: string[] = [];
  email: string = '';
  
  constructor(private route: ActivatedRoute, private authService: AuthService, private router: Router, private loader: LoadingService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const otp = params['otp'];
      if (otp) {
        const otpPattern = /^[0-9]{6}$/;
        if (!otpPattern.test(otp)) {
          alert('Please enter a valid OTP');
          return;
        }
        this.updateOtp(otp);
      }

      const email = params['email'];
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        alert('Please enter a valid email address');
        return;
      }
      this.email = email;
    });
  }

  updateOtp(otp: string) {
    this.otpValues = otp.split('');
    this.otpArray = this.otpValues.map((value) => (value ? value : ''));    
  }

  onInput(event: Event, index: number): void {
    const input = event.target as HTMLInputElement;

    if (input.value.length > 1) {
      input.value = input.value.slice(0, 1);
    }

    // Move declaration + usage inside the same block
    const nextInput = document.querySelectorAll('.otp-input')[
      index + 1
    ] as HTMLInputElement;

    if (input.value.length === 1 && index < this.otpArray.length - 1) {
      nextInput?.focus();
    } else if (index === this.otpArray.length - 1) {
      input.blur();
    }

    // Optionally, handle backspace
    if (input.value.length === 0 && index > 0) {
      const prevInput = document.querySelectorAll('.otp-input')[
        index - 1
      ] as HTMLInputElement;
      prevInput?.focus();
    }
  }

  verifyOtp() {
    this.loader.showLoading();
    this.authService.verifyOtp(this.email, this.otpValues.join('')).subscribe({
      next: (response: any) => {
        this.loader.hideLoading();
        this.router.navigate(['/reset-password'], {
          state: { email: this.email },
        });
      },
      error: (error) => {
        this.loader.hideLoading();
      }
    });
  }

  forgotPassword() {
    this.loader.showLoading();
    this.authService.forgotPassword(this.email).subscribe({
      next: (response: any) => {
        this.loader.hideLoading();
        alert('OTP has been sent to your email');
      },
      error: (error) => {
        this.loader.hideLoading();
      },
    });
  }
}
